var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import forSize from '../../mediaQueries';
/**
 * A js file containing exports that relate to
 * the functionality and styles of the Anchor component.
 * The component uses styled-components to render.
 * @object
 * @returns {JSX.Element} - Rendered component (define any specifics if applicable)
 */

var Anchor = styled.a(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  text-decoration: none;\n  display: flex;\n\n  @media ", " {\n    display: inline-flex;\n  }\n"])), forSize.medium);
export default Anchor;